<template>
    <div class="list-x">
        <div style="height: 100%;position: relative;">
          <hua-loading v-if="isLoading" class="loading-box" size="32px" vertical>
              加载中，请稍后...
        </hua-loading>
            <div v-if="!isLoading" class="top-x">
                <!-- <hua-index-anchor :index="item + '月'" /> -->
                <div class="left-check">
                    <template v-if="!active && !isVistorList">
                        <hua-checkbox class="checkAll" v-model="checkAllFlag" @click="checkAll">全选</hua-checkbox>
                        <div class="btnBox">
                          <hua-button class="btn" @click="batchApprove(true)">批量通过</hua-button>
                          <hua-button class="btn" @click="batchApprove(false)">批量拒绝</hua-button>
                        </div>
                    </template>
                </div>
                <div @click.stop="timeClick" class="right-time">
                    <div>{{dateStr[0]}} 至 </div>
                    <div>{{dateStr[1]}} <hua-icon name="arrow-down" /></div>
                </div>
            </div>
            <!-- 访客列表 -->
            <div v-if="!isLoading && isVistorList" class="card-x" style="position: relative;">
                <template v-for="(items, index) in alreadyData">
                    <record-cell
                        class="card-item"
                        :key="items.id"
                        :item="items"
                        :v_personid="v_personid"
                        :index="index"
                        :active="active"
                        style="border-radius: 10px;overflow: hidden;"
                    ></record-cell>
                </template>
                 <div v-if="!isLoading && !alreadyData.length" class="no-data">暂无数据</div>
            </div>
            <!-- 待审核、在访、离访、已取消 -->
            <div v-if="!isLoading && !isVistorList" class="card-x" style="position: relative;">
                <hua-checkbox-group v-model="result" direction="horizontal" @change="changeWaitInfo" ref="checkboxGroup">
                    <div class="check-item" v-for="(items, index) in waitData" :key="items.id">
                        <hua-checkbox v-if="active === 0" :name="items" class="card-item check-box">
                        </hua-checkbox>
                        <record-cell
                            :isBooking="false"
                            :key="items.id"
                            :item="items"
                            :v_personid="v_personid"
                            :index="index"
                            :active="active"
                            @refreshData="getReviewList"
                        ></record-cell>
                    </div>
                 </hua-checkbox-group>
                 <div v-if="!isLoading && !waitData.length" class="no-data">暂无数据</div>
            </div>
        </div>
        <!-- </hua-index-bar> -->
        <hua-popup
          v-if="isDateShow"
          v-model="visible"
          position="bottom"
          :style="{ height: '55%' }"
          :close-on-click-overlay="false"
        >
          <hua-datetime-picker
            show-rangebar
            v-model="dateVal"
            type="date"
            title="选择年月日"
            :formatter="formatter"
            @cancel="isDateShow = false"
            @confirm="handleConfirm"
          />
        </hua-popup>
    </div>
</template>

<script>
import api from '@/constants/api'
import recordCell from './recordCell.vue'
import moment from 'moment'
import image from '@/image/head.jpg'
import utils from '@/constants/utils'

export default {
    components: {
        recordCell,
    },
    props: {
        v_personid: {
            type: String,
            require: true,
        },
        userId: {
            type: [String, Number],
        },
        active: {
            require: true,
        },
        // 是否为访客列表，只有我的访客页面的访客列表此值为true
        isVistorList: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: true,
            waitMonth: [],
            alreadyMonth: [],
            waitData: [],
            alreadyData: [],
            result:[],
            checkAllFlag:false,
            visible: true,
            isDateShow: false,
            dateVal: [],
            dateStr: [], // 年月日
            defaultImage: image,
        }
    },
    watch: {
        isLoading: {
            handler(newVal) {
                console.log('isLoadingisLoading', newVal);
            }
        }
    },
    mounted() {
        // this.$nextTick(() => {
        //     console.log(this.$route.path)
        //     this.$toast({ message: this.$route.path, duration: 0 })
        // })
        const startT = moment().subtract(2, 'day').format('YYYY-MM-DD')
        const endT = moment().add(4, 'day').format('YYYY-MM-DD')
        this.dateStr = [startT, endT]
        // this.dateStr = moment(this.dateVal).format('YYYY-MM-DD')
        if (this.v_personid || this.userId) {
            // 切换tab时调用
            this.getReviewList()
        }
    },
    methods: {
        moment,
        formatter(type, value) {
          if (type === 'year') {
            return value + '年';
          }
          if (type === 'month') {
            return value + '月';
          }
          if (type === 'day') {
            return value + '日';
          }
          if (type === 'hour') {
            return value + '时';
          }
          if (type === 'minute') {
            return value + '分';
          }
          if (type === 'second') {
            return value + '秒';
          }
          return value;
        },
        handleConfirm(value) {
            console.log('dateChange====', value)
            this.dateStr = [
                moment(value[0]).format('YYYY-MM-DD'),
                moment(value[1]).format('YYYY-MM-DD'),
            ]
            this.isDateShow = false
            this.getReviewList()
        },
        timeClick() {
            this.dateVal = [
                new Date(this.dateStr[0]),
                new Date(this.dateStr[1]),
            ]
            this.isDateShow = true
        },
        changeWaitInfo() {
            console.log(this.result,"result=============");
        },
        // 全选
        checkAll () {
            if (this.checkAllFlag) {
                this.$refs.checkboxGroup.toggleAll(true);
            } else {
                this.$refs.checkboxGroup.toggleAll()
            }
        },
        // 批量审批/拒绝
        batchApprove(flag) {
            if(this.result.length === 0) {
                this.$toast('请至少选择一条记录')
            } else {
                let batchParamList = [];
                this.result.forEach(item => {
                    let obj = {
                        id: item.id,
                        visitorType: 2,
                        result: flag,
                        appointTime: item.v_time,
                        areaIdList: [],
                        times: 9999,   // 默认访问次数为9999
                        secondVisitorType: item.secondVisitorType,
                        personId: localStorage.getItem('v_personid') ? JSON.parse(localStorage.getItem('v_personid')) :'',
                        approvalOpinion: ""   // 审批意见
                    }
                    batchParamList.push(obj)
                })
                // console.log(batchParamList,"batchParamList==========")
                try {
                    api.batchReview(batchParamList)
                    .then((res) => {
                        this.$toast('操作成功')
                        this.getReviewList()
                    })
                    .catch((err) => {
                        console.log(err,"err=========")
                        this.$toast(err.errMsg || '获取审核列表失败')
                    })
                } catch (error) {
                    this.$toast(error)
                }
            }
        },
        // 刚进入页面时由父组件调用一次
        getReviewList(id, isApprove) {
            // 从审核管理页面调用此方法时isApprove为true，此时只需要获取审核列表不要访客列表
            this.isLoading = true
            console.log('activeactive', this.active)
            const statusMap = {
                0: 0,
                1: 2,
                2: 3,
                3: 4,
                4: 1,
            }
            const pId = id || this.v_personid || ''
            let params = {
                pageNum: 1, //页码
                // pageSize: 1000, //每页大小
                pageSize: 200,
                personId : pId ? Number(pId) : '', //被访人ID
                startDate: this.dateStr[0],
                endDate: this.dateStr[1],
                // dateStr: this.dateStr
                // "status":0//状态
            }
            // this.active===0待审核，1在访，2离访，3已取消
            // 后端接口入参status对应===0待审核，2在访，3离访，4已取消
            this.waitMonth = []
            this.alreadyMonth = []
            this.waitData = []
            this.alreadyData = []
            api.getReviewList({
                ...params,
                status: this.isVistorList ? 0 : statusMap[this.active],
                // dateStr: this.dateStr
            })
                .then((res) => {
                    console.log('resres88', res)
                    let data = res.data.pageData
                    data.map((item) => {
                        if (item.v_capturePic) {
                            item.v_capturePic = this.getImageUrl(item.v_capturePic, item.id)
                        }
                        // if (item.status === 0) {
                            this.waitMonth.push(item.v_timeStr.split('-')[1])
                            this.waitData.push(item)
                        // }
                        // else {
                        //     this.alreadyMonth.push(item.v_timeStr.split('-')[1])
                        //     this.alreadyData.push(item)
                        // }
                    })
                    // this.waitData = []
                    console.log('waitDatawaitData', this.waitData);
                    this.waitMonth = [...new Set(this.waitMonth)]
                    this.alreadyMonth = [...new Set(this.alreadyMonth)]
                    isApprove ? this.isLoading = false : ''
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                    isApprove ? this.isLoading = false : ''
                })
                // 审批页面就不用继续获取访客列表了
                if(isApprove) {
                    return
                }
                api.getVisitorList(params)
                .then((res) => {
                    let data = res.data.pageData
                    data.map((item) => {
                        if (item.v_capturePic) {
                            item.v_capturePic = this.getImageUrl(item.v_capturePic, item.id)
                        }
                        // if (item.status === 0) {
                        //     this.waitMonth.push(item.v_timeStr.split('-')[1])
                        //     this.waitData.push(item)
                        // } else {
                            this.alreadyMonth.push(item.v_timeStr.split('-')[1])
                            this.alreadyData.push(item)
                        // }
                    })
                    console.log('this.alreadyData111', this.alreadyData);
                    this.waitMonth = [...new Set(this.waitMonth)]
                    this.alreadyMonth = [...new Set(this.alreadyMonth)]
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                    this.isLoading = false
                })
        },
        // 刚进入页面时由父组件调用一次
        getVisitorList(id) {
            this.alreadyMonth = []
            this.alreadyData = []
            this.waitMonth = []
            let params = {
                pageNum: 1, //页码
                pageSize: 50, //每页大小
                personId : id || this.v_personid, //被访人ID
                // "status":0//状态
            }
            api.getVisitorList(params)
                .then((res) => {
                    let data = res.data.pageData
                    data.map((item) => {
                        if (item.v_capturePic) {
                            item.v_capturePic = this.getImageUrl(item.v_capturePic, item.id)
                        }
                        // if (item.status === 0) {
                        //     this.waitMonth.push(item.v_timeStr.split('-')[1])
                        //     this.waitData.push(item)
                        // } else {
                            this.alreadyMonth.push(item.v_timeStr.split('-')[1])
                            this.alreadyData.push(item)
                        // }
                    })
                    this.waitMonth = [...new Set(this.waitMonth)]
                    this.alreadyMonth = [...new Set(this.alreadyMonth)]
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                })
        },
        getImageUrl(url, id) {
            console.log('waitAudit-------------getImageUrl', url, id, utils.getImgUrl(url, id));
            return utils.getImgUrl(url, id) || this.defaultImage
        },
    },
}
</script>
<style lang="less">
.list-x {
    height: calc(100vh - 100px);
    // padding: 10px;
    .top-x {
        z-index: 9999;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        background-color: #ffffff;
        .left-check {
            display: flex;
        }
        .checkAll{
            margin: 0 8px 0 3px;
        }
        .btnbox {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .btn {
              height: 26px;
              padding: 0 8px;
              font-size: 14px;
              margin-right: 8px !important;
              background-color: #e7eaf3;
              color: #000000;
              border: none;
              // margin-left: 5px;
          }

    }
    .card-x {
        height: calc(100% - 86px);
        padding: 10px 10px;
        overflow: auto;
        .check-item {
            width: 100%;
            position: relative;
            margin-bottom: 15px;
            display: flex;
            background-color: #ffffff;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
            .check-box {
                position: absolute;
                top: 24px;
                left: 0;
            }
        }
        .card-item {
            margin-bottom: 15px;
            background-color: #fff;
        }
        .hua-checkbox-group--horizontal{
            justify-content: space-around;
            .hua-checkbox--horizontal{
                margin-right: 0;
                .hua-checkbox__icon{
                    margin-left: 5px;
                }
                .hua-checkbox__label{
                    margin-left: 0.03rem;
                }
            }
        }
    }
    .my-confirm-content {
        padding: 20px 10px;
        text-align: center;
    }
}
</style>
<style lang="less" scoped>
.no-data {
    width: 100%;
    // height: 100%;
    padding-top: 100px;
    text-align: center;
}
.loading-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 99%;
    height: 100%;
    position: absolute;
    top: -95px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
}
</style>
